export default "__VITE_ASSET__81bf94e8__"